import {toast} from "react-toastify";

const MoneyTax = ({formDataPage, formChangeHandlerSection}) => {
  return (
    <>

      <div className="row">
        <div className="col-md-4">
          <h5>
            <i className="fa fa-money-bill ms-1"></i>واحد پولی
          </h5>
          <select
            // ref={monetaryUnit}
            className="form-control" name="STR1"
            value={formDataPage.currency.STR1}
            onChange={(event) => formChangeHandlerSection("currency", "STR1", event.target.value)}
          >
            <option value={"ریال"}>ریال</option>
            <option value={"تومان"}>تومان</option>
          </select>
        </div>
        <div className="col-md-4">
          <h5>
            <i className="fa fa-percent ms-1" aria-hidden="true"></i>
            درصد مالیات
          </h5>
          <input
            type="number"
            className={"form-control py-1"}
            style={{padding: '6px 10px !important'}}

            value={formDataPage.tax}
            onChange={(event) => {
              const value = event.target.value;
              if (+value > 100 || +value < 0) {

                toast.info('مالیات فقط بین 0 تا صد قابل قبول است.')
                return
              }
              formChangeHandlerSection("tax", null, value);

            }}
          />
        </div>
      </div>


    </>
  );
};

export default MoneyTax;
